module.exports = __webpack_public_path__ + "img/fp-spread1.6de2456c.webp";